import { ApiError } from '../api/models/apiError';

export function useApiCall(apiFunc: any) {
	async function request(...args: any[]): Promise<any> {
		let result: any = '';

		try {
			console.log(`calling api function`, apiFunc.name, args);
			result = await apiFunc(...args);
			console.log('api function complete');
		} catch (error: any) {
			console.error(`Error calling API function ${apiFunc.name}:`, error);
			const statusCode = error.response?.status || 500;
            console.error(`API error status code: ${statusCode}`);

			if (error.response?.data) {
                console.error(`throw API error data A:`, error.response.data);
				throw new ApiError(error.response.data.message, statusCode);
			} else {
                console.error(`throw API error data B:`, error.response.data);
				throw new ApiError(error.message, statusCode);
			}
		}

		return result;
	}

	return {
		request,
	};
}
